import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios'
import { ROOT_API_URL } from '../../../../../../api-config';
import { withRouter } from 'react-router-dom';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { addAddons, addDonations, getAddons, getDonationTypes } from '../../../../../../Redux/Actions/EndUser/MembershipAction';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import './Addons.scss';
import { toASCII } from 'punycode';

import { loader, toastr } from '../../../../../../Redux/Actions/CommonActions';
import IsLoading from '../../../../../Shared/Loading/IsLoading';

const successColor = "success";
const errorColor = "danger";
const warningColor = "warning";

class Addons extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            addons: [],
            donations: [],
            totalAmount: 0,
            userId:""
        }
    }

    componentDidMount() {
        const userId = this.props.membership.userId;
        let total = 0;

        this.setState({
           userId: userId
        }); 

        this.props.loader(true);
        //If we haven't loaded addons yet, load them (first time we get to addons page)
        if (!this.props.membership.allAddonOptions) {
            this.props.getAddons();
        }
        else {
            this.initializeAddons();                 
        }
        //If we haven't loaded the donation types yet
        if (!this.props.membership.allDonationOptions) {
            this.props.getDonationTypes();
        }
        else {
            this.initializeDonations();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.membership.allAddonOptions !== this.props.membership.allAddonOptions) {
            this.initializeAddons();
        }
        if (prevProps.membership.allDonationOptions !== this.props.membership.allDonationOptions) {
            this.initializeDonations();
        }
    }

    initializeAddons = () => {
        let addonsForDisplay = [...this.props.membership.allAddonOptions];
        //If addons were already selected
        if (this.props.membership.addons.AddtoCartList) {
            addonsForDisplay.map(addon => {
                let a = this.props.membership.addons.AddtoCartList.filter(a => a.productId == addon.productId)[0];
                addon.quantity = a? a.quantity:0;
                addon.color = a ? a.color : addon.colors.length != 0 ? addon.colors[0].description : null;
                addon.colorId = a? a.colorId: addon.colors.length ? addon.colors[0].colorOptionId : null;
                addon.size = a? a.size: addon.sizes.length != 0 ? addon.sizes[0].description : null;
                addon.sizeId = a? a.sizeId: addon.sizes.length != 0 ? addon.sizes[0].sizeOptionId : null;
            });
        }
        //If not, set all quantities to 0, and colors/sizes to the first value initially
        else {
            addonsForDisplay.map(addon => {
                addon.quantity = 0;
                addon.color = addon.colors.length != 0 ? addon.colors[0].description : null;
                addon.colorId = addon.colors.length ? addon.colors[0].colorOptionId : null;
                addon.size = addon.sizes.length != 0 ? addon.sizes[0].description : null;
                addon.sizeId = addon.sizes.length != 0 ? addon.sizes[0].sizeOptionId : null;
            });
        }

        // rename key name "image" to "imageModel".
        addonsForDisplay.map(addon => {
            if (addon.hasOwnProperty('image')) {
                addon.imageModel = addon.image;
                delete addon.image;
            }
        });

        this.setState({
            addons: addonsForDisplay
        }, () => {
            this.total();
        });
        
    }

    initializeDonations = () => {
        let donationsForDisplay = [...this.props.membership.allDonationOptions];
        //Get only donations that should appear on addons
        donationsForDisplay = donationsForDisplay.filter(donation => donation.isAddon);
        let total = 0;
        //If donations were already selected
        if (this.props.membership.donations.length != 0) {
            donationsForDisplay.map(donation => {
                let d = this.props.membership.donations.filter(d => d.id == donation.id)[0];
                donation.amount = d ? d.amount : 0;
            });
        }
        //If not, set all quantities to 0, and colors/sizes to the first value initially
        else {
            donationsForDisplay.map(donation => {
                donation.amount = 0;
            });
        }
        this.setState({
            donations: donationsForDisplay
        }, () => {
            this.total();
        });
    }

    qtyChange = (event, id) => {
        let target = event.target;
        const value = target.value;

        if (value.match(/^(0)$|^(0*[1-9][0-9]*)$|^$/) || value == "") {
            let editedAddons = [...this.state.addons];
            let index = editedAddons.findIndex(el => el.productId == id);
            editedAddons[index].quantity = value == "" ? value : target.valueAsNumber;
            this.setState({
                addons: editedAddons
            }, () => {
                this.total();
            });
        }
    }

    toggleQty = (event, id) => {
        let target = event.target.parentElement.getElementsByTagName('input')[0];
        const value = target.value == "0" ? 1 : 0;

        //if (value.match(/^(0)$|^(0*[1-9][0-9]*)$|^$/) || value == "") {
        let editedAddons = [...this.state.addons];
        let index = editedAddons.findIndex(el => el.productId == id);
        editedAddons[index].quantity = value;
        this.setState({
            addons: editedAddons
        }, () => {
            this.total();
        });
        //}
    }

    qtyBlur = (event, id) => {
        let target = event.target;
        const value = target.value;

        if (!value) {
            let editedAddons = [...this.state.addons];
            let index = editedAddons.findIndex(el => el.productId == id);
            editedAddons[index].quantity = 0;
            this.setState({
                addons: editedAddons
            }, () => {
                this.total();
            });
        }
    }

    colorChange = (event) => {
        let target = event.target;
        const value = target.value;
        let editedAddons = [...this.state.addons];
        let index = editedAddons.findIndex(el => el.productId == value.productId);
        editedAddons[index].color = value.description; 
        editedAddons[index].colorId = value.colorOptionId;

        this.setState({
            addons: editedAddons
        });  
    }


    sizeChange = (event) => {
        let target = event.target;
        const value = target.value;
        let editedAddons = [...this.state.addons];
        let index = editedAddons.findIndex(el => el.productId == value.productId);
        editedAddons[index].size = value.description;
        editedAddons[index].sizeId = value.sizeOptionId;

        this.setState({
            addons: editedAddons
        });  
    }
    
    back = () => {
        var pickedItems = []
        for (var i = 0; i < this.state.addons.length; i++) {
            if (this.state.addons[i].quantity > 0) {
                pickedItems.push(this.state.addons[i]);
            }
        }
        var model = {
            UserId: this.state.userId,
            AddtoCartList: pickedItems
        }

        this.props.addAddons(model);
        this.props.addDonations(this.state.donations.filter((donation) => {
            return (donation.amount > 0);
        }));
        let t = this.state.donations.filter((donation) => {
            return (donation.amount > 0);
        });
        this.props.previousStep()
    }

    next = () => {
        var pickedItems = []
        for (var i = 0; i < this.state.addons.length; i++) {
            if (this.state.addons[i].quantity > 0) {
                pickedItems.push(this.state.addons[i]);
            }
        }
        var model = {  
            UserId:this.state.userId,
            AddtoCartList:pickedItems
        }

        this.props.addAddons(model);
        this.props.addDonations(this.state.donations.filter((donation) => {
            return (donation.amount > 0);
        }));
        this.props.nextStep();
    }

    handleChange = (event) => {
        let editedDonations = [...this.state.donations];
        let index = editedDonations.findIndex(el => {
            return el.name == event.target.name
        });

        editedDonations[index].amount = event.target.value;

        this.setState({
            donations: editedDonations,
        }, () => {
            this.total()
        });
    }

    total = () => {
        var total = 0;

        for (var i = 0; i < this.state.addons.length; i++) {

            var addonQty = this.state.addons[i].quantity || 0;

            if (addonQty > 0) {
                if (this.state.addons[i].discount) {
                    total += addonQty * this.state.addons[i].discount;
                } else {
                    total += addonQty * this.state.addons[i].price;
                }
            }
        }

        for (var i = 0; i < this.state.donations.length; i++) {
            if (this.state.donations.length > 0) {
                total += this.state.donations[i].amount;
            }
        }

        this.setState({
            totalAmount: total
        })
    }

    render() {
        return (
            <div className="addonsSignupContainer">
                <div className="cols">
                    <div className="col-lg-7 addonList col-left">
                        <h1 className="pt-3 pb-3">Add-ons</h1>
                        <h3>Membership Add-ons</h3>
                        <p className="subHeading">Would you like to purchase any of these items with your membership?</p>
                        <div className="row">
                            {this.props.membership.allAddonOptions && this.props.membership.allDonationOptions? this.state.addons ? this.state.addons.map((product, index) => {
                                return (
                                    <div className="row product" key={index}>
                                        <div className="col-md-4">
                                            {
                                                product.imageModel.base64 ? 
                                                (<img src={product.imageModel.base64} className="addOnsImg" />) 
                                                :(<img src="/images/TSCRABackgroundLOGO.png" className="addOnsImg" />)
                                            }
                                            
                                        </div>
                                        <div className="col-md-4">
                                            <h4 className="addonTitle">{product.title}</h4>
                                            {product.discount ? 
                                                <div>
                                                    <p className="addonPrice" style={{
                                                        textDecoration: "line-through"
                                                    }}>${product.price}</p> 
                                                    <p className="addonPrice">${product.discount}</p> 
                                                </div> :

                                                <p className="addonPrice">${product.price}</p> 
                                            }
                                            <div className="addonDescription">{product.productDescription}</div>                                                  
                                        </div>
                                    
                                        <div className="col-md-4">
                                            <div className="paddingColumn">
                                            {
                                                product.colors.length != 0 ?
                                                    <div className="dropdownSmallStyle">
                                                        <DropDownList
                                                            data={product.colors}
                                                            defaultItem={product.colorId != 0 ? product.colors.filter(c => c.colorOptionId == product.colorId)[0]: product.colors[0]}
                                                            //value={}
                                                            onChange={this.colorChange}
                                                            textField="description"
                                                            dataItemKey="colorOptionId"
                                                            allowCustom={true}
                                                            className="dropdownSmallStyle"
                                                            />
                                                    </div>
                                                    : ""
                                                }
                                            </div>
                                            <div className="paddingColumn">
                                                {
                                                    product.sizes.length != 0 ?
                                                        <div className="dropdownSmallStyle">
                                                            <p className="productPrice">
                                                                <DropDownList
                                                                    data={product.sizes}
                                                                    defaultItem={product.sizeId != 0 ? product.sizes.filter(c => c.sizeOptionId == product.sizeId)[0] : product.sizes[0] }
                                                                    onChange={this.sizeChange}
                                                                    textField="description"
                                                                    dataItemKey="sizeOptionId"
                                                                    allowCustom={true}
                                                                    className="dropdownSmallStyle"
                                                                />
                                                            </p>
                                                        </div>
                                                    : ""
                                                }
                                            </div>
                                            <div className="paddingColumn">
                                                <div className="quantityInput">
                                                    <p style={{ display: "none" }}>Quantity</p>
                                                    <button
                                                        className="btnPrimary"
                                                        onClick={(e) => { this.qtyBlur(e, product.productId); this.toggleQty(e, product.productId); }}
                                                    >
                                                        { Number(product.quantity) > 0 ? "Remove to cart" : "Add to cart" }
                                                    </button>

                                                    <input style={{ display: "none" }}
                                                        type='number'
                                                        className="dropdownSmallStyle hidden"
                                                        value={(product.quantity).toString() ? Number(product.quantity).toString() : (product.quantity).toString()}
                                                        onChange={(e) => this.qtyChange(e, product.productId)}
                                                        onBlur={(e) => this.qtyBlur(e, product.productId)}
                                                        name="Quantity"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }) : "":""}
                        </div>
                        <h1 className="pt-3 pb-3">Donations</h1>
                        <p className="subHeading">Your contributions are very important to the success of our organization. Please consider making an additional donation to help us achieve our collective goals.</p>
                        <div className="row">
                            {this.props.membership.allAddonOptions && this.props.membership.allDonationOptions ?this.state.donations.map((donation) => {
                                return (
                                    <div className="col-md-8">
                                        <label>{donation.name}</label>
                                        <NumericTextBox
                                            defaultValue={donation.amount}
                                            format="c2"
                                            min={0} 
                                            onChange={this.handleChange}
                                            name={donation.name}
                                        />
                                    </div>
                                    )
                                })
                            :""}
                        </div>
                        <div>
                            <div className="col-md-6 buttonContainer">
                                <p className="addonsTotal">Total: <span className="addonsTotalPrice">${this.state.totalAmount}</span></p>
                                <button className="signUpBtns mb-3 btnPrimary" onClick={this.back}>Back</button>
                                <button className="signUpBtns mb-3 btnPrimary" onClick={() => this.next()}>Next</button>
                            </div>
                            <div className="col-md-6 info-text"></div>                        
                        </div>
                    </div>
                    <div className="col-lg-5 billingBackground col-right">
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
      membership:state.membership
    }
}

export default withRouter(connect(mapStateToProps, { addAddons, loader, getAddons, getDonationTypes, addDonations })(Addons));